import { createBrowserRouter, Outlet, redirect } from "react-router-dom";
import ErrorPage from "./pages/error-page";
import React, { useEffect } from "react";
import { Login } from "./pages/login";
import { CheckIns } from "./pages/checkIns";
import { CheckInDetail } from "./pages/checkInDetail";
import { FanInfoPageByTicket } from "./pages/fanInfoPageByTicket";
import { validateLoginStatus } from "./utils/validator";
import { QrScannerPage } from "./pages/qrScannerPage";
import { NotCheckedInList } from "./pages/notCheckedInList";
import { CheckedInUser } from "./pages/checkedInUser";
import { Notices } from "./pages/notices";
import Maintenance from "./pages/maintenance";
import { BackstageLogin } from "./pages/backstageLogin";
import { useAtom } from "jotai";
import { userAtom } from "./atoms/userAtom";
import { AdminUser } from "./models/adminUser";
import { GetSessionToken } from "./utils/store";
import { NoticeEditor } from "./pages/noticeEditor";
import { logout } from "./utils/logout";
import { LogoutDialog } from "./components/common/logoutDialog";
import SecurityPledgePage from "./pages/SecurityPledgePage";

function ProtectedRouteLayout() {
  const isLoggedIn = validateLoginStatus();
  const [admin, setAdmin] = useAtom(userAtom);

  useEffect(() => {
    const sessionToken = GetSessionToken();
    if (isLoggedIn) {
      if (!admin && sessionToken) {
        try {
          setAdmin(new AdminUser(sessionToken));
        } catch (_) {
          logout();
        }
      }
    } else {
      logout();
    }
  }, [admin, isLoggedIn, setAdmin]);
  return (
    <>
      <div className={"h-svh"}>{isLoggedIn && <Outlet />}</div>
      <LogoutDialog />
    </>
  );
}

const router = createBrowserRouter([
  {
    id: "root",
    errorElement: <ErrorPage />,
    element: <ProtectedRouteLayout />,
    children: [
      { index: true, element: <CheckIns /> },
      {
        path: "events/checkins",
        element: <CheckIns />,
      },
      {
        path: "artists/:artistId/events/:eventId/rewards/:rewardId",
        element: <CheckInDetail />,
      },
      {
        path: "artists/:artistId/events/:eventId/rewards/:rewardId/scanner",
        element: <QrScannerPage />,
      },
      {
        path: "artists/:artistId/events/:eventId/rewards/:rewardId/user",
        element: <FanInfoPageByTicket />,
      },
      {
        path: "artists/:artistId/events/:eventId/rewards/:rewardId/notCheckedIn",
        element: <NotCheckedInList />,
      },
      {
        path: "artists/:artistId/events/:eventId/rewards/:rewardId/checkedIn",
        element: <CheckedInUser />,
      },
      {
        path: "artists/:artistId/events/:eventId/rewards/:rewardId/notices/:noticeId?",
        element: <Notices />,
      },
      {
        path: "artists/:artistId/events/:eventId/rewards/:rewardId/noticeForm/:noticeId?",
        element: <NoticeEditor />,
      },
      {
        path: "artists/:artistId/events/:eventId/rewards/:rewardId/notices/:noticeId/noticeForm",
        element: <NoticeEditor />,
      },
      {
        path: "security-pledge",
        element: <SecurityPledgePage />,
      },
    ],
  },
  {
    path: "maintenance",
    element: <Maintenance />,
  },
  {
    path: "login",
    element: <Login />,
    loader: () => {
      if (validateLoginStatus()) {
        return redirect("/events/checkins");
      }
      return null;
    },
  },
  {
    path: "login/backstage",
    element: <BackstageLogin />,
  },
]);

export { router as Router };
